import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const useQuoteStatuses = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      DRAFT: t("Draft"),
      SENT: t("Sent"),
      DECLINED: t("Declined"),
      ACCEPTED: t("Accepted"),
      INVOICED: t("Invoiced"),
      DELETED: t("Deleted"),
    }),
    [t]
  );
};
